import "./../scss/main.scss";

import $ from "jquery";
import "bootstrap";
